export const STRINGS = {
  TEMOIGNAGE: 'Témoignages',
  AIDE_EDITEUR: `Aide de l'éditeur`,
  INSERER_TEXT_ICI: `« insérer du texte ici »`,
  REDIMENSIONER_30: `Redimensionner l'image à 30%`,
  REDIMENSIONER_50: `Redimensionner l'image à 50%`,
  REDIMENSIONER_100: `Redimensionner l'image à 100%`,
  BON_A_SAVOIR: 'Bon à savoir'
};
